<template>
  <eg-b-form-group
    :label-for="labelFor"
    :class="isCustom ? 'custom-form-group' : ''"
  >
    <template v-if="label" #label>
      {{ label }}
      <span v-if="required" class="red-text">*</span>
      <span v-if="optionalLabel" class="optional-text"
        >({{ $t("common.optional") }})</span
      >

      <eg-b-icon
        v-if="info"
        v-b-popover.hover.top="info"
        class="ml-2 delete-question-icon"
        icon="question-circle"
      />

      <p v-if="showDescription" class="text-muted small mb-0 mt-0">
        <slot v-if="$slots.description" name="description"></slot>
        <template v-else>
          {{ description }}
        </template>
      </p>
    </template>
    <slot />
    <div v-if="hint" class="hint">{{ hint }}</div>
  </eg-b-form-group>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: "",
    },
    labelFor: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
    optionalLabel: {
      type: Boolean,
      default: false,
    },
    hint: {
      type: String,
      default: "",
    },
    info: {
      type: String,
      default: "",
    },
    isCustom: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    showDescription() {
      return this.$slots.description || this.description;
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-form-group {
  margin-bottom: 1.5rem;

  &::v-deep {
    .col-form-label {
      font-weight: var(--typography-font-weight-fw-600);
      padding-bottom: 0.5rem;
    }
  }

  .optional-text {
    color: var(--color-text-neutral-fade);
    font-weight: var(--typography-font-weight-fw-400);
    font-size: var(--typography-font-size-fs-300);
  }

  .hint {
    color: var(--color-text-neutral-fade);
    font-size: var(--typography-font-size-fs-200);
    margin-top: 4px;
  }
}
</style>
